import React from 'react';

import { contractTypes, contractUpdateTypes, multipleContractsUpdateTypes } from '../contracts/actions'

const initialState = {
    isFetching: false,
    results: []
}

export function contracts(state = initialState, action) {

    switch(action.type) {

        case contractTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case contractTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.results.push(action.data)
            return state

        case contractUpdateTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case contractUpdateTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.photoUploadStatus = action.data
            return state

        case contractUpdateTypes.ERROR:
            state = {...state, isFetching: false}
            state.photoUploadStatus = action.error
            return state

        case multipleContractsUpdateTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.photoUploadStatus = action.data
            return state

        case multipleContractsUpdateTypes.REQUEST:
            state = {...state, isFetching: false}
            state.photoUploadStatus = action.data
            return state

        case multipleContractsUpdateTypes.ERROR:
            state = {...state, isFetching: false}
            state.photoUploadStatus = action.error
            return state

        default:
            return state
    }
}